import { h, empty } from '../../../../../src/shared/components/dom.js';
import { state } from '../../state.js';
import { makeToggle, DISCOVERY_MODULES, PREFS_KEY } from '../../components/toggle.js';
import { invalidateCache } from '../index/index-screen.js';

function buildDiscoveryCard() {
  if (state.get().features?.discovery === false) return h('span');

  const card = h('div', { class: 'lib-settings-card' },
    h('h2', null, 'Discovery'),
    h('p', null, 'Choose which discovery sections appear on the library home page.'),
  );

  for (const mod of DISCOVERY_MODULES) {
    const wrap = h('div', { class: 'lib-settings-toggle-row' });
    const active = state.get().prefs?.discovery?.[mod.id] !== false;

    function mount(on) {
      empty(wrap);
      wrap.appendChild(makeToggle(mod.label, on, (val) => {
        const prefs = { ...state.get().prefs, discovery: { ...state.get().prefs?.discovery, [mod.id]: val } };
        state.set({ prefs });
        try { localStorage.setItem(PREFS_KEY, JSON.stringify(prefs)); } catch { /* quota */ }
        invalidateCache();
        mount(val);
      }));
    }

    mount(active);
    card.appendChild(wrap);
  }

  return card;
}

export function render(_params, { root }) {
  empty(root);

  const section = h('section', { class: 'lib-settings-screen' },
    h('h1', null, 'Library settings'),

    buildDiscoveryCard(),
  );

  root.appendChild(section);
}
